import { render, staticRenderFns } from "./step-install.vue?vue&type=template&id=498b47a5&"
import script from "./step-install.vue?vue&type=script&lang=js&"
export * from "./step-install.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports